import React, { memo, useLayoutEffect } from 'react';

import { Drawer } from 'antd';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string | JSX.Element;
  children: React.ReactNode;
}

const getDrawerContainer = () => document.documentElement;

const QuickView = memo(({ open, onClose, title, children }: IProps) => {
  useLayoutEffect(() => {
    if (!open) {
      return undefined;
    }

    const html = document.documentElement;
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    const previousOverflow = html.style.overflow;
    const previousGutter = html.style.scrollbarGutter;
    const previousPaddingRight = html.style.paddingRight;

    html.style.scrollbarGutter = 'auto';
    html.style.overflow = 'hidden';
    html.style.paddingRight = `${scrollbarWidth}px`;

    return () => {
      html.style.overflow = previousOverflow;
      html.style.scrollbarGutter = previousGutter;
      html.style.paddingRight = previousPaddingRight;
    };
  }, [open]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      width='min(420px, 100%)'
      destroyOnHidden
      getContainer={getDrawerContainer}
    >
      {children}
    </Drawer>
  );
});

export default QuickView;
